export const Modulecolumns = [
  { field: "id", headerName: "ID", flex: 0.5 },
  { field: "module", headerName: "Module", flex: 1 },
  { field: "company", headerName: "Company", flex: 1 },
];

export const RightsColumns = [
  { field: "id", headerName: "ID", flex: 0.5 },
  { field: "title", headerName: "Title", flex: 1 },
  { field: "icon", headerName: "Icon", flex: 1 },
  { field: "action", headerName: "Action", flex: 1 },
  { field: "module", headerName: "Module", flex: 1 },
];
export const RoleGroupColumns = [
  { field: "id", headerName: "ID", flex: 0.5 },
  { field: "roleGroup", headerName: "Role Group", flex: 1 },
];
